import { Pipe, PipeTransform } from '@angular/core';
import { StatusWeryfikacjiWOswiadczeniuODochodach } from '@interfaces/stypendia/oswiadczenia-o-dochodach/weryfikacja/status-weryfikacji-w-oswiadczeniu-o-dochodach.enum';

@Pipe({
  name: 'statusWeryfikacjiNazwa',
})
export class StatusWeryfikacjiNazwaPipe implements PipeTransform {
  transform(value: StatusWeryfikacjiWOswiadczeniuODochodach): string {
    const { Zatwierdzono, NieZatwierdzono, NieSprawdzono } = StatusWeryfikacjiWOswiadczeniuODochodach;
    switch (value) {
      case NieSprawdzono:
        return $localize`Nie sprawdzono`;
      case Zatwierdzono:
        return $localize`Tak`;
      case NieZatwierdzono:
        return $localize`Nie`;
      default:
        return '';
    }
  }
}
